import React, { useState } from 'react';
import * as Routes from '@/modules/routes';
import useFlags from '@/hooks/useFlags';
import TeacherSessionActivePopup from '@/components/staffer/TeacherSessionActivePopup';

// AIDEV-NOTE: PLAT-17264 — Host abandon-session popup. Suppressed on /present_mode (host
// already presenting) and gated by the teacherPacedMode LD flag.
interface TeacherLiveSessionListenerProps {
  parentId: number;
  parentType: string;
  programId: number;
  sessionId: string;
  slideShowId: number;
}

const isOnPresentMode = () => window.location.pathname.includes('/present_mode');

const TeacherLiveSessionListener = ({
  parentId,
  parentType,
  programId,
  sessionId,
  slideShowId,
}: TeacherLiveSessionListenerProps) => {
  const { teacherPacedMode } = useFlags();
  const [isOpen, setIsOpen] = useState(() => !isOnPresentMode());

  if (!teacherPacedMode) return null;

  const handleRejoinClick = () => {
    window.location.assign(
      Routes.present_mode_shared_slide_show_path(slideShowId, {
        parent_id: parentId,
        parent_type: parentType,
        program_id: programId,
        via: 'teacher_popup',
      }),
    );
  };

  const handleEndSuccess = () => {
    setIsOpen(false);
  };

  return (
    <TeacherSessionActivePopup
      isOpen={isOpen}
      sessionId={sessionId}
      onEndSuccess={handleEndSuccess}
      onRejoinClick={handleRejoinClick}
    />
  );
};

export default TeacherLiveSessionListener;
